import { getSessionStorage, setSessionStorage } from '../../utils/browser';
import { CHECK_DELAY, MAX_ATTEMPTS } from '../constants';

/**
 * @type {import('../index.d').getVariantIdFromUrl}
 */
export const getVariantIdFromUrl = () => {
  const url = new URL(window.location.href);
  const variantParam = url.searchParams.get('variant');
  const isValidVariantId = variantParam && /^\d+$/.test(variantParam);
  return isValidVariantId ? variantParam : '';
};

/**
 * @type {import('../index.d').initEventChangeVariantUrl}
 */
export const initEventChangeVariantUrl = (context) => {
  document.addEventListener('click', function checkVariantId() {
    let attempts = 0;
    const preVariantId = getSessionStorage('preVariantIdSelected');

    const check = () => {
      const [, setVariant] = context.useContextState('bis-variant', {});
      const currentVariantId = getVariantIdFromUrl();

      if (currentVariantId && currentVariantId !== preVariantId) {
        setSessionStorage('preVariantIdSelected', currentVariantId);
        const variantSelected = window.boostSDData.product?.variants?.find(
          (variant) => String(variant?.id) === String(currentVariantId)
        );
        setVariant(variantSelected);
      } else if (attempts < MAX_ATTEMPTS) {
        attempts++;
        setTimeout(check, CHECK_DELAY);
      }
    };

    check();
  });
};
